import { EXTERNAL_LOAN_DEFAULT_DAILY_INTEREST_RATE_PERCENT } from '../constants/externalLoanConstants';
import {
  calculateExternalLoanEligibilityStatus,
  calculateExternalLoanTerms,
} from './externalLoanCalculator';

export const calculateEligibleAmount = (currentSavings = 0, protectedSavingsPercentage = 0.2) => {
  const safeCurrentSavings = Number(currentSavings) || 0;
  const safePercentage = Number(protectedSavingsPercentage) || 0;
  return Math.max(0, safeCurrentSavings * (1 - safePercentage));
};

export const externalLoanApplicantProfileFields = [
  'fullName',
  'phoneNumber',
  'governmentIdType',
  'governmentIdNumber',
  'groupName',
  'memberReference',
];

const resolveApplicantProfile = (source = {}) => {
  if (Object.prototype.hasOwnProperty.call(source || {}, 'applicantProfile')) {
    return source?.applicantProfile || {};
  }
  return source || {};
};

export const validateApplicantProfile = (source = {}) => {
  const errors = {};
  const applicantProfile = resolveApplicantProfile(source);

  externalLoanApplicantProfileFields.forEach((field) => {
    if (!String(applicantProfile[field] || '').trim()) errors[field] = 'Required.';
  });
  if (!applicantProfile.governmentIdType || !applicantProfile.governmentIdNumber) {
    errors.identity = 'Government identification is not available in your member profile.';
  }
  return errors;
};

export const validateExternalLoanForm = ({
  amount,
  dailyInterestRatePercent = EXTERNAL_LOAN_DEFAULT_DAILY_INTEREST_RATE_PERCENT,
  repaymentTerm,
  purpose,
  eligibleAmount,
}) => {
  const errors = {};
  const safeAmount = Number(amount);
  const safeDailyInterestRatePercent = Number(dailyInterestRatePercent);
  const safeRepaymentTerm = Number(repaymentTerm);
  const safeEligibleAmount = Number(eligibleAmount) || 0;

  if (!amount || !Number.isFinite(safeAmount) || safeAmount <= 0) {
    errors.amount = 'Loan amount is required.';
  }

  if (
    dailyInterestRatePercent === ''
    || !Number.isFinite(safeDailyInterestRatePercent)
    || safeDailyInterestRatePercent <= 0
  ) errors.dailyInterestRatePercent = 'Daily interest rate must be greater than 0.';

  if (repaymentTerm === '' || repaymentTerm === null || repaymentTerm === undefined) {
    errors.repaymentTerm = 'Repayment term is required.';
  } else if (!Number.isFinite(safeRepaymentTerm) || !Number.isInteger(safeRepaymentTerm) || safeRepaymentTerm < 1) {
    errors.repaymentTerm = 'Repayment term must be a whole number of days greater than zero.';
  }

  if (!purpose || !String(purpose).trim()) {
    errors.purpose = 'Purpose is required.';
  }

  const loanTerms = calculateExternalLoanTerms({
    loanAmount: amount,
    dailyInterestRatePercent,
    numberOfDays: repaymentTerm,
    maximumEligibleAmount: safeEligibleAmount,
  });
  const eligibilityStatus = calculateExternalLoanEligibilityStatus({
    totalPayable: loanTerms.totalPayable,
    maximumEligibleAmount: safeEligibleAmount,
  });
  if (loanTerms.valid && !eligibilityStatus.isWithinEligibility) {
    errors.eligibility = 'Total payable cannot exceed the maximum eligible amount.';
  }

  return { isValid: Object.keys(errors).length === 0, errors };
};
